/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FacilityRegionFacility
 */
export interface FacilityRegionFacility {
    /**
     * 
     * @type {string}
     * @memberof FacilityRegionFacility
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityRegionFacility
     */
    name: string;
}

/**
 * Check if a given object implements the FacilityRegionFacility interface.
 */
export function instanceOfFacilityRegionFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FacilityRegionFacilityFromJSON(json: any): FacilityRegionFacility {
    return FacilityRegionFacilityFromJSONTyped(json, false);
}

export function FacilityRegionFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityRegionFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FacilityRegionFacilityToJSON(value?: FacilityRegionFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

